import { FC } from 'react';
import cn from 'classnames';
import { Modal, ModalProps } from 'antd';
import styles from '@app/account/login/index.module.less';
import LoginForm from '@base/account/login/LoginForm';
import RegisterForm from '@base/account/login/RegisterForm';

type LoginModalProps = ModalProps & {
    onLoginSuccess?: () => void;
};

const LoginModal: FC<LoginModalProps> = props => {
    const {
        onLoginSuccess,
        onCancel,
        visible,
        ...rest
    } = props;

    const handleLoginSuccess = () => {
        typeof onLoginSuccess === 'function' && onLoginSuccess();
        // @ts-ignore
        typeof onCancel === 'function' && onCancel();
    };

    return (
        <Modal
            open={visible}
            wrapClassName={styles.modal}
            width={750}
            title={false}
            footer={false}
            maskClosable={false}
            onCancel={onCancel}
            destroyOnClose
            keyboard={false}
            centered
            {...rest}
        >
            <div className={cn('flex', styles.wrapper)}>
                <div className={styles.col}>
                    <h2 className="text-center">Sign In</h2>
                    <LoginForm onLoginSuccess={handleLoginSuccess} showThirdLogin={false}/>
                </div>
                <div className={styles.col}>
                    <h2 className="text-center">Register</h2>
                    <RegisterForm onLoginSuccess={handleLoginSuccess}/>
                </div>
            </div>
        </Modal>
    )
};

export default LoginModal;